import { format } from 'date-fns';

/**
 * Formats a date to DD-MMM-YYYY format
 * Example: 04-Jan-2025
 */
export const formatDate = (date: string | Date): string => {
  const d = new Date(date);
  return format(d, 'dd-MMM-yyyy');
};

/**
 * Formats a date to DD-MMM-YYYY HH:mm format
 * Example: 04-Jan-2025 14:30
 */
export const formatDateTime = (date: string | Date): string => {
  const d = new Date(date);
  return format(d, 'dd-MMM-yyyy HH:mm');
};

/**
 * Formats a date to DD-MMM-YYYY hh:mm A format
 * Example: 04-Jan-2025 02:30 PM
 */
export const formatDateTimeWithAMPM = (date: string | Date): string => {
  const d = new Date(date);
  return format(d, 'dd-MMM-yyyy hh:mm a');
};